import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css'; 


import Wallbox from './Wallbox/Wallbox';  
import WallboxSingle from './Wallbox/WallboxSingle'; 
import ChargeEvents from './ChargeEvents/ChargeEvents'; 
import User from './User/User';  
import UserSingle from './User/UserSingle';
import Roles from './User/Roles';
import Permissions from './User/Permissions'; 

import Login from './Login/Login';


import './App.scss'; 

const App = () => {

  return (
    <>  
      <Router>  
        <Switch> 
          <Route exact path='/' component={Wallbox} /> 
          <Route exact path='/wallbox_single' component={WallboxSingle} />
          <Route exact path='/chargeEvents' component={ChargeEvents} />
          <Route exact path='/user' component={User} /> 
          <Route exact path='/user_single' component={UserSingle} /> 
          <Route exact path='/roles' component={Roles} /> 
          <Route exact path='/permissions' component={Permissions} /> 
          <Route exact path='/login' component={Login} />
          
        </Switch>
            
      </Router>
      
 
    </>
  )
}

export default App
